import { post, get } from '@/api/request'
import { getDeviceInfo } from '@/utils/device'

export const requestVerificationCode = (data: any) => {
    return post('/api/solve-x-ai/user/email/v1-10-3/code', data)
}

export const bindDevice = async () => {
    const data = await getDeviceInfo()

    return post('/api/solve-x-ai/device/register-device', data, {
        auth: false
    })
}

export const getUserInfo = async () => {
    return post('/api/solve-x-ai/appuser/get-user-info')
}

export const emailLogin = async (data: any) => {
    return post('/api/solve-x-ai/user/email/login', data)
}

export const googleLogin = async (data: any) => {
    return post('/api/solve-x-ai/user/google/login', data)
}

export const appleLogin = async (data: any) => {
    return post('/api/solve-x-ai/user/apple/login', data)
}

export const saveUserProfile = async (data: any) => {
    return post('/api/solve-x-ai/appuser/save-user-profile', data)
}

export const deleteAccount = () => {
    return post('/api/solve-x-ai/appuser/delete-user')
}

export const getGrade = () => {
    return post('/api/solve-x-ai/appuser/get-grade-level-dict')
}

export const saveGrade = (data: any) => {
    return post('/api/solve-x-ai/appuser/save-grade', data)
}

export const getUnreadMessagCount = () => {
    return get('/api/solve-x-ai/operate/feedback/get_unread_feedback_message_count')
}

export const getUserSubscriedInfo = () => {
    return post('/api/solve-x-ai/appuser/get-user-subscried_info')
}

export const checkUserIsSubscribe = (payload: string) => {
    return get(`/api/solve-x-ai/appuser/check-user-is-subscribe?payload=${encodeURIComponent(String(payload || '').trim())}`)
}

/** 绑定 Firebase Web 端 GA4 client_id */
export interface BindUserThirdPlatformIdPayload {
    firebaseClientId: string
}

export const bindUserThirdPlatformId = (data: BindUserThirdPlatformIdPayload) => {
    return post('/api/solve-x-ai/appuser/bind-user-third-platform-id', data)
}

export interface BindUserParentEmailPayload {
    userId: string | number
    parentEmail: string
}

export const bindUserParentEmail = (data: {payload: string}) => {
    return post('/api/solve-x-ai/appuser/bind-user-parent-email', data)
}

/**
 * 获取二维码
 * @returns
 */
export const getQrCode = () => {
    return post('/api/solve-x-ai/user/qrcode/get')
}

/**
 * 二维码登录
 * @returns
 */
export const qrCodeLogin = async (qrcode: string) => {
    const { deviceCode } = await getDeviceInfo()

    return post('/api/solve-x-ai/user/qrcode/login', { code: qrcode, deviceCode: deviceCode })
}
